import Column from '@components/Column';
import CustomBarcode from '@components/CustomBarcode';
import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import Info from '@icons/info/Info';
import { useTranslation } from 'react-i18next';

const EXAMPLE_CODE = '1234 5678 9012 3456';

function BarcodeExample() {
    const { t } = useTranslation('gift');

    return (
        <Container fullWidth spacing={3}>
            <BarcodeContainer aria-hidden='true'>
                <BarcodeWrapper>
                    <CustomBarcode value={EXAMPLE_CODE} height={42} />
                </BarcodeWrapper>
                <Overlay />
                <TextWrapper>
                    <Text size='title' align='center'>{EXAMPLE_CODE}</Text>
                </TextWrapper>
            </BarcodeContainer>
            <Row spacing={2} align='center'>
                <Info size={16}
                    color='#6E6864' />
                <Text size='body-long' color={colors.textSecondary}>
                    {t('newGift.barcodeHint')}
                </Text>
            </Row>
        </Container>
    );
}

const Container = styled(Column)`
    padding: var(--spacing-4);
    border-radius: 8px;
    background-color: ${colors.gray1};
`;

const BarcodeContainer = styled.div`
    display: flex;
    position: relative;
    justify-content: center;
    width: 100%;
    height: 94px;
    padding-top: 10px;
    border-radius: 8px;
    overflow: hidden;
`;

const BarcodeWrapper = styled.div`
    padding: 0 48px;
`;

const Overlay = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.4);
`;

const TextWrapper = styled.div`
    position: absolute;
    bottom: 10px;
    width: calc(100% - 64px);
    padding: 3px 0;
    border: 2px solid ${colors.red};
    background-color: ${colors.white};
`;

export default BarcodeExample;
